export default "__VITE_ASSET__CbFvvUeW__"